export const URLS = {
  SE: {
    domain: {
      sv: 'https://www.postnord.se',
      en: 'https://www.postnord.se/en',
    },
    contact: {
      sv: 'https://www.postnord.se/kundservice',
      en: 'https://www.postnord.se/en/help-and-support/contact-us',
    },
    cookies: {
      sv: 'https://www.postnord.se/cookies',
      en: 'https://www.postnord.se/en/cookies',
    },
    privacy: {
      sv: 'https://www.postnord.se/integritetspolicy',
      en: 'https://www.postnord.se/en/privacy-policy',
    },
    terms: {
      sv: 'https://www.postnord.se/siteassets/pdf/villkor/anvandarvillkor-postnord-konto.pdf',
      en: 'https://www.postnord.se/siteassets/pdf/villkor/anvandarvillkor-postnord-konto.pdf',
    },
  },
  DK: {
    domain: {
      da: 'https://www.postnord.dk',
      en: 'https://www.postnord.com/en',
    },
    contact: {
      da: 'https://www.postnord.dk/kundeservice',
      en: 'https://www.postnord.dk/en/help-and-support',
    },
    cookies: {
      da: 'https://www.postnord.dk/cookies',
      en: 'https://www.postnord.dk/en/cookies',
    },
    privacy: {
      da: 'https://www.postnord.dk/personlige-oplysninger',
      en: 'https://www.postnord.se/en/privacy-policy',
    },
    terms: {
      da: 'https://www.postnord.dk/contentassets/4806069a7d6c44959c94b13417d78f22/kundeportalen.pdf',
      en: 'https://www.postnord.dk/kundeservice/kundeservice-erhverv/forretningsbetingelser',
    },
  },
  FI: {
    domain: {
      fi: 'https://www.postnord.fi',
      sv: 'https://www.postnord.fi/sv',
      en: 'https://www.postnord.fi/en',
    },
    contact: {
      fi: 'https://www.postnord.fi/asiakaspalvelu/ota-yhteytta',
      sv: 'https://www.postnord.fi/sv/kundtjanst',
      en: 'https://www.postnord.fi/en/customer-service',
    },
    cookies: {
      fi: 'https://www.postnord.fi/yksityisyydensuoja/tietoa-evasteista',
      sv: 'https://www.postnord.fi/sv/integritetspolicy/information-om-cookies',
      en: 'https://www.postnord.fi/en/privacy-policy/information-about-the-cookies',
    },
    privacy: {
      fi: 'https://www.postnord.fi/yksityisyydensuoja',
      sv: 'https://www.postnord.fi/sv/integritetspolicy',
      en: 'https://www.postnord.se/en/privacy-policy',
    },
    terms: {
      fi: 'https://www.postnord.fi/laheta/sopimusehdot',
      sv: 'https://www.postnord.fi/sv/skicka/villkor',
      en: 'https://www.postnord.fi/en/sending/terms',
    },
  },
  NO: {
    domain: {
      no: 'https://www.postnord.no',
      en: 'https://www.postnord.no/en',
    },
    contact: {
      no: 'https://www.postnord.no/kundeservice',
      en: 'https://www.postnord.no/en/contact-postnord',
    },
    cookies: {
      no: 'https://www.postnord.no/cookies',
      en: 'https://www.postnord.no/en/cookies',
    },
    privacy: {
      no: 'https://www.postnord.no/personvernerklaering',
      en: 'https://www.postnord.se/en/privacy-policy',
    },
  },
  contact: 'https://portal.postnord.com/customerservice',
};
